import React, { useState, useEffect, useRef } from 'react';
import { useStateValue } from './StateProvider';
import axios from 'axios';
import configData from './Config';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import ReactToPrint from 'react-to-print';
import autoTable from 'jspdf-autotable';
import jsPDF from 'jspdf';
import StatementAccount from "./StatementAccount";
import { registerArabicFont } from "./Utils/registerarabicfont.js";

import {
    getgeneralledgerreportdata, getgeneralledgersummarydata, getreceiptspaymentsreportdata,
    getprofitlossreportdata, getinvoicesreportdata,
    getItemsQuantityData, getItemsValueData, getClientBalancesColumn,
    getbalancesheetreportdata,
    getcashflowstatementdata,
} from "./Utils/reports.js";

import { getAssetAccounts } from './Utils/assetaccounts.js';
import { getLiabilityAccounts } from './Utils/liabilityaccounts.js';
import { getCashAccounts } from './Utils/cashaccounts.js';
import { getEquityAccounts } from './Utils/equityaccounts.js';

import { getTrialbalance } from './Utils/trialbalance.js';
import { getSupplierAccounts } from './Utils/suppliers.js';
import { getStaffAccounts } from './Utils/staff.js';
import Select from './Components/select.js';

import Title from './Title';

import './Reports.css';

const countryCoa = [
    { id: 'standard', name: 'Standard' },
    { id: 'lebanon', name: 'Lebanon' },
];

const basisTypes = [
    { id: 'cash', name: 'Cash' },
    { id: 'accrual', name: 'Accrual' }
]

function Reports({ state, setState }) {
    const [{ project }, dispatch] = useStateValue();

    const [from, setFrom] = useState(new Date());
    const [fromts, setFromTs] = useState(0);
    const [to, setTo] = useState(new Date());
    const [tots, setToTs] = useState(0);

    const [option, setOption] = useState(null);

    useEffect(() => {
        setFrom(new Date(project.startdate * 1000))
    }, [project]);

    useEffect(() => {
        const startOfDay = new Date(from);
        startOfDay.setHours(0, 0, 0, 0);
        const fromTs = Math.floor(startOfDay.getTime() / 1000);
        setFromTs(fromTs);
    }, [from]);

    useEffect(() => {
        const endOfDay = new Date(to);
        endOfDay.setHours(23, 59, 59, 999);
        const toTs = Math.floor(endOfDay.getTime() / 1000);
        setToTs(toTs);
    }, [to]);

    const handleGeneralLedger = () => {
        setOption(<GeneralLedger />);
    }

    const handleReceiptsPayments = () => {
        setOption(<ReceiptsPayments />);
    }

    const handleProfitLoss = () => {
        setOption(<ProfitLoss />);
    }

    const handleBalanceSheet = () => {
        setOption(<BalanceSheet />);
    }

    const handleCashFlow = () => {
        setOption(<CashFlow />);
    }

    const handleTrialBalance = () => {
        setOption(<TrialBalance />);
    }

    const handleInvoicesReport = () => {
        setOption(<InvoicesReport />);
    }

    const handleItemsQuantityReport = () => {
        setOption(<ItemsQuantity />);
    };

    const handleItemsValueReport = () => {
        setOption(<ItemsValue />);
    };

    const handleOverallReport = () => {
        setOption(<OverallReport />);
    };

    const handleAccountStatement = (type, account) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <StatementAccount state={state} setState={setState} type={type} account={account} />, modaltype: 'large', modaltitle: 'Statement of Account' }));
    };

    function GeneralLedger() {
        const [reportdata, setReportdata] = useState([]);
        const [generalledgersummary, setGeneralledgersummary] = useState([]);

        const [selectedcurrencyid, setSelectedcurrencyid] = useState(project.basecurrency);

        const printRef = useRef();

        useEffect(() => {
            const context = {
                ...project,
                fromts: fromts,
                tots: tots,
                selectedcurrencyid: selectedcurrencyid
            };

            const generalledgerreportdata = getgeneralledgerreportdata(context)
            setReportdata(generalledgerreportdata)

            const generalledgersummarydata = getgeneralledgersummarydata(context)
            setGeneralledgersummary(generalledgersummarydata)
        }, [fromts, tots, selectedcurrencyid]);

        return (
            <div className='report'>
                <div className="reports_row">
                    <div className="reports_rowsection">
                        Currency
                    </div>
                    <div className="reports_rowsection">
                        <Select data={project.currencies} itemid={selectedcurrencyid} setItemid={setSelectedcurrencyid} />
                    </div>
                </div>
                <div className="reports_buttonscontainer">
                    <ReactToPrint
                        trigger={() => (<button className="reports_button">Print</button>)}
                        content={() => printRef.current}
                    />
                </div>
                <div className="reports_printable" ref={printRef}>
                    <div className="reports_headerrow">
                        <div className="reports_headercolleft">
                            {project.projectdetailsimage && (
                                <img
                                    className="reports_projectdetailsimage"
                                    src={project.projectdetailsimage}
                                    alt="Project Details Image"
                                />
                            )}
                        </div>
                        <div className="reports_headercolmiddle">
                            <div className="reports_title">General Ledger</div>
                            <div className="reports_projectname">{project.name}</div>
                            <div className="reports_projectdetails">Currency: {project.currencies.find((curr) => curr.id === selectedcurrencyid)?.name}</div>
                            <div className="reports_dateframe">
                                {moment.unix(fromts).format("D/MMM/YYYY") + ' to ' + moment.unix(tots).format("D/MMM/YYYY")}
                            </div>
                        </div>
                        <div className="reports_headercolright"></div>
                    </div>

                    <div className="reports_rowsection">
                        <table className="reports_table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Type</th>
                                    <th>Account</th>
                                    <th>Name</th>
                                    <th>Debit</th>
                                    <th>Credit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    reportdata.map((data, index) => {
                                        if (data.tabletype == 'item') {
                                            return (
                                                <tr
                                                    key={"data" + index}
                                                    className="reports_tableitem"
                                                >
                                                    <td><div>{data.date}</div></td>
                                                    <td><div>{data.type}</div></td>
                                                    <td><div>{data.accounttype}</div></td>
                                                    <td><div>{data.name}</div></td>
                                                    <td><div>{data.currency + ' ' + data.debit.toLocaleString("en-US")}</div></td>
                                                    <td><div>{data.currency + ' ' + data.credit.toLocaleString("en-US")}</div></td>
                                                </tr>
                                            );
                                        }
                                        if (data.tabletype == 'sectiontotal') {
                                            return (
                                                <tr
                                                    key={"data" + index}
                                                    className="reports_tablesectiontotal"
                                                >
                                                    <td colSpan={4}><div>Total</div></td>
                                                    <td><div>{data.currency + ' ' + data.debit.toLocaleString("en-US")}</div></td>
                                                    <td><div>{data.currency + ' ' + data.credit.toLocaleString("en-US")}</div></td>
                                                </tr>
                                            );
                                        }
                                    })
                                }
                            </tbody>
                        </table>
                    </div>

                    <div className="reports_row">
                        <div className="reports_rowsection">
                            <table className="reports_table">
                                <thead>
                                    <tr>
                                        <th>Type</th>
                                        <th>Debit</th>
                                        <th>Credit</th>
                                        <th>Balance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        generalledgersummary.map((data, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td>{data.name}</td>
                                                    <td>{data.currency + ' ' + data.debit.toLocaleString("en-US")}</td>
                                                    <td>{data.currency + ' ' + data.credit.toLocaleString("en-US")}</td>
                                                    <td>
                                                        {data.currency + ' ' + data.balance.toLocaleString("en-US")}
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        )
    }

    function ReceiptsPayments() {
        const [reportdata, setReportdata] = useState([]);

        const [selectedcurrencyid, setSelectedcurrencyid] = useState(project.basecurrency);
        const [selectedcashaccountid, setSelectedcashaccountid] = useState('');

        const [loadingpdf, setLoadingpdf] = useState(false);
        const [resultpdf, setResultpdf] = useState('');

        const printRef = useRef();

        useEffect(() => {
            const context = {
                ...project,
                fromts: fromts,
                tots: tots,
                selectedcurrencyid: selectedcurrencyid,
                selectedcashaccountid: selectedcashaccountid,
            };

            const getreceiptspaymentsreport = getreceiptspaymentsreportdata(context)
            setReportdata(getreceiptspaymentsreport)
        }, [fromts, tots, selectedcurrencyid, selectedcashaccountid]);

        const saveAsPDF = () => {
            setLoadingpdf(true);
            try {
                const projectName = project.name;

                const doc = new jsPDF();
                registerArabicFont(doc);

                const pageWidth = doc.internal.pageSize.getWidth();
                let currentY = 10;

                currentY += 10;
                doc.setFontSize(24);
                const title = 'Receipts & Payments Report';
                const titleWidth = doc.getTextWidth(title);
                doc.text(title, (pageWidth - titleWidth) / 2, currentY);

                currentY += 10;
                doc.setFontSize(10);
                doc.text('Project Name: ' + projectName, 10, currentY);

                currentY += 5;
                const formattedFrom = moment.unix(fromts).format("D/MMM/YYYY");
                const formattedTo = moment.unix(tots).format("D/MMM/YYYY");
                doc.text('From: ' + formattedFrom, 10, currentY);
                currentY += 5;
                doc.text('To: ' + formattedTo, 10, currentY);

                currentY += 10;
                const tableColumn = ['Date', 'Name', 'Amount'];

                const tableData = reportdata.map((data) => {
                    if (data.tabletype == 'section') return [
                        { content: data.name, colSpan: 3, styles: { fontStyle: 'bold' } },
                    ];
                    if (data.tabletype == 'sectiontotal') return [
                        { content: data.name, colSpan: 2, styles: { fontStyle: 'bold' } },
                        { content: data.currency + ' ' + data.amount.toLocaleString("en-US"), styles: { fontStyle: 'bold', halign: 'right' } }
                    ];
                    if (data.tabletype == 'item') return [
                        { content: data.date, styles: { fontStyle: 'normal', halign: 'left' } },
                        { content: data.name, styles: { fontStyle: 'normal', halign: 'left' } },
                        { content: data.currency + ' ' + data.amount.toLocaleString("en-US"), styles: { fontStyle: 'normal', halign: 'right' } }
                    ];
                });

                autoTable(doc, {
                    head: [tableColumn],
                    body: tableData,
                    startY: currentY,
                    theme: 'grid',
                    headStyles: {
                        fillColor: [200, 200, 200],
                        textColor: [0, 0, 0],
                        fontStyle: 'bold',
                    },
                    bodyStyles: {
                        fontSize: 10,
                        textColor: [0, 0, 0],
                        font: 'notoarabic',
                    },
                    columnStyles: {
                        0: { halign: 'left' },
                        1: { halign: 'left' },
                        2: { halign: 'left' },
                    },
                    margin: { top: 10, left: 10, right: 10 },
                });

                const fileName = 'Receipts Payments ' + projectName + '.pdf';
                doc.save(fileName.replace(/\s+/g, '_').toLowerCase());
                setResultpdf("Saved Successfully");
            } catch (error) {
                console.error('Error generating PDF:', error);
                setResultpdf("Error Saving PDF");
            } finally {
                setLoadingpdf(false);
            }
        };

        return (
            <div className='report'>
                <div className="reports_row">
                    <div className="reports_rowsection">
                        Currency
                    </div>
                    <div className="reports_rowsection">
                        <Select data={project.currencies} itemid={selectedcurrencyid} setItemid={setSelectedcurrencyid} />
                    </div>
                    <div className="reports_rowsection">
                        Cash Account
                    </div>
                    <div className="reports_rowsection">
                        <Select data={[{ id: '', name: 'All' }, ...project.cashaccounts]} itemid={selectedcashaccountid} setItemid={setSelectedcashaccountid} />
                    </div>
                </div>
                <div className="reports_buttonscontainer">
                    <ReactToPrint
                        trigger={() => (<button className="reports_button">Print</button>)}
                        content={() => printRef.current}
                    />
                    <button className="reports_button" onClick={saveAsPDF} disabled={loadingpdf}>
                        Save as PDF {loadingpdf && '(Loading...)'} {resultpdf && "(" + resultpdf + ")"}
                    </button>
                </div>
                <div className="reports_printable" ref={printRef}>
                    <div className="reports_headerrow">
                        <div className="reports_headercolleft">
                            {project.projectdetailsimage && (
                                <img
                                    className="reports_projectdetailsimage"
                                    src={project.projectdetailsimage}
                                    alt="Project Details Image"
                                />
                            )}
                        </div>
                        <div className="reports_headercolmiddle">
                            <div className="reports_title">Receipts & Payments Report</div>
                            <div className="reports_projectname">{project.name}</div>
                            <div className="reports_projectdetails">Cash Account: {project.cashaccounts.find((cash) => cash.id === selectedcashaccountid)?.name || 'All'}, Currency: {project.currencies.find((curr) => curr.id === selectedcurrencyid)?.name || 'All'}</div>
                            <div className="reports_dateframe">
                                {moment.unix(fromts).format("D/MMM/YYYY") + ' to ' + moment.unix(tots).format("D/MMM/YYYY")}
                            </div>
                        </div>
                        <div className="reports_headercolright"></div>
                    </div>
                    <table className="reports_table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Name</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                reportdata
                                    .map((data, index) => {
                                        if (data.tabletype == 'section') {
                                            return (
                                                <tr
                                                    key={"data" + index}
                                                    className="reports_tablesection"
                                                >
                                                    <td colSpan={3}>
                                                        <div>{data.name}</div>
                                                    </td>
                                                </tr>

                                            )
                                        }
                                        if (data.tabletype == 'sectiontotal') {
                                            return (
                                                <tr
                                                    key={"data" + index}
                                                    className="reports_tablesectiontotal"
                                                >
                                                    <td colSpan={2}>
                                                        <div>{data.name}</div>
                                                    </td>
                                                    <td>
                                                        <div>{data.currency + ' ' + data.amount.toLocaleString("en-US")}</div>
                                                    </td>
                                                </tr>

                                            )
                                        }
                                        if (data.tabletype == 'item') return (
                                            <tr
                                                key={"data" + index}
                                                className="reports_tableitem"
                                            >
                                                <td>
                                                    <div>{data.date}</div>
                                                </td>
                                                <td>
                                                    <div>{data.name}</div>
                                                </td>
                                                <td>
                                                    <div>{data.currency + ' ' + data.amount.toLocaleString("en-US")}</div>
                                                </td>
                                            </tr>
                                        );
                                    })
                            }
                        </tbody>
                    </table>
                </div>
            </div >
        )
    }

    function ProfitLoss() {
        const [reportdata, setReportdata] = useState([]);

        const [selectedcurrencyid, setSelectedcurrencyid] = useState(project.basecurrency);
        const [selectedsubaccountid, setSelectedsubaccountid] = useState(project?.subaccounts[0]?.id);

        const [loadingpdf, setLoadingpdf] = useState(false);
        const [resultpdf, setResultpdf] = useState('');

        const printRef = useRef();

        useEffect(() => {
            const context = {
                ...project,
                fromts: fromts,
                tots: tots,
                selectedcurrencyid: selectedcurrencyid,
                selectedsubaccountid: selectedsubaccountid,
            };

            const getprofitlossreport = getprofitlossreportdata(context)
            setReportdata(getprofitlossreport)
        }, [fromts, tots, selectedcurrencyid, selectedsubaccountid]);

        const saveAsPDF = () => {
            setLoadingpdf(true);
            try {
                const projectName = project.name;

                const doc = new jsPDF();
                registerArabicFont(doc);

                const pageWidth = doc.internal.pageSize.getWidth();
                let currentY = 10;

                currentY += 10;
                doc.setFontSize(24);
                const title = 'Profit & Loss Statement';
                const titleWidth = doc.getTextWidth(title);
                doc.text(title, (pageWidth - titleWidth) / 2, currentY);

                currentY += 10;
                doc.setFontSize(10);
                doc.text('Project Name: ' + projectName, 10, currentY);

                currentY += 5;
                const formattedFrom = moment.unix(fromts).format("D/MMM/YYYY");
                const formattedTo = moment.unix(tots).format("D/MMM/YYYY");
                doc.text('From: ' + formattedFrom, 10, currentY);
                currentY += 5;
                doc.text('To: ' + formattedTo, 10, currentY);

                currentY += 5;
                doc.setFontSize(10);
                const cashAccountName = project.cashaccounts.find(cash => cash.id === selectedcurrencyid)?.name || 'All';
                doc.text('Cash Account: ' + cashAccountName, 10, currentY);

                currentY += 5;
                doc.setFontSize(10);
                const subAccountName = project.subaccounts.find(sub => sub.id === selectedsubaccountid)?.name || 'All';
                doc.text('Subaccount: ' + subAccountName, 10, currentY);

                currentY += 10;
                const tableColumn = ['Name', 'Actual'];

                const tableData = reportdata.map((data) => {
                    if (data.tabletype == 'section') return [
                        { content: data.name, colSpan: 2, styles: { fontStyle: 'bold' } },
                    ];
                    if (data.tabletype == 'sectiontotal') return [
                        { content: data.name, styles: { fontStyle: 'bold' } },
                        { content: data.currency + ' ' + data.amount.toLocaleString("en-US"), styles: { fontStyle: 'bold', halign: 'right' } }
                    ];
                    if (data.tabletype == 'group') return [
                        { content: data.name, colSpan: 2, styles: { fontStyle: 'bold' } },
                    ];
                    if (data.tabletype == 'grouptotal') return [
                        { content: data.name, styles: { fontStyle: 'bold' } },
                        { content: data.currency + ' ' + data.amount.toLocaleString("en-US"), styles: { fontStyle: 'bold', halign: 'right' } }
                    ];
                    if (data.tabletype == 'item') return [
                        { content: data.name, styles: { fontStyle: 'normal', halign: 'left' } },
                        { content: data.currency + ' ' + data.amount.toLocaleString("en-US"), styles: { fontStyle: 'normal', halign: 'right' } }
                    ];
                });

                autoTable(doc, {
                    head: [tableColumn],
                    body: tableData,
                    startY: currentY,
                    theme: 'grid',
                    headStyles: {
                        fillColor: [200, 200, 200],
                        textColor: [0, 0, 0],
                        fontStyle: 'bold',
                    },
                    bodyStyles: {
                        fontSize: 10,
                        textColor: [0, 0, 0],
                        font: 'notoarabic',
                    },
                    columnStyles: {
                        0: { halign: 'left' },
                        1: { halign: 'right' },
                        2: { halign: 'right' },
                        3: { halign: 'center' },
                    },
                    margin: { top: 10, left: 10, right: 10 },
                });

                const fileName = 'Profit and loss statement ' + projectName + '.pdf';
                doc.save(fileName.replace(/\s+/g, '_').toLowerCase());
                setResultpdf("Saved Successfully");
            } catch (error) {
                console.error('Error generating PDF:', error);
                setResultpdf("Error Saving PDF");
            } finally {
                setLoadingpdf(false);
            }
        };

        return (
            <div className="report">
                <div className="reports_row">
                    <div className="reports_rowsection">
                        Currency
                    </div>
                    <div className="reports_rowsection">
                        <Select data={[{ id: '', name: 'All' }, ...project.currencies]} itemid={selectedcurrencyid} setItemid={setSelectedcurrencyid} />
                    </div>
                    <div className="reports_rowsection">
                        Subaccount
                    </div>
                    <div className="reports_rowsection">
                        <Select data={project.subaccounts} itemid={selectedsubaccountid} setItemid={setSelectedsubaccountid} />
                    </div>
                </div>
                <div className="reports_buttonscontainer">
                    <ReactToPrint
                        trigger={() => (<button className="reports_button">Print</button>)}
                        content={() => printRef.current}
                    />
                    <button className="reports_button" onClick={saveAsPDF} disabled={loadingpdf}>
                        Save as PDF {loadingpdf && '(Loading...)'} {resultpdf && "(" + resultpdf + ")"}
                    </button>
                </div>
                <div className="reports_printable" ref={printRef}>
                    <div className="reports_headerrow">
                        <div className="reports_headercolleft">
                            {project.projectdetailsimage && (
                                <img
                                    className="reports_projectdetailsimage"
                                    src={project.projectdetailsimage}
                                    alt="Project Details Image"
                                />
                            )}
                        </div>
                        <div className="reports_headercolmiddle">
                            <div className="reports_title">Profit & Loss Statement</div>
                            <div className="reports_projectname">{project.name}</div>
                            <div className="reports_projectdetails">Subaccount: {project.subaccounts.find((sub) => sub.id === selectedsubaccountid)?.name || 'All'}</div>
                            <div className="reports_dateframe">
                                {moment.unix(fromts).format("D/MMM/YYYY") + ' to ' + moment.unix(tots).format("D/MMM/YYYY")}
                            </div>
                        </div>
                        <div className="reports_headercolright"></div>
                    </div>
                    <table className="reports_table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                reportdata.map((data, index) => {
                                    if (data.tabletype == 'section') {
                                        return (
                                            <tr key={"data" + index} className="reports_tablesection">
                                                <td colSpan={2}>
                                                    <div>{data.name}</div>
                                                </td>
                                            </tr>
                                        );
                                    }
                                    if (data.tabletype == 'sectiontotal') {
                                        return (
                                            <tr key={"data" + index} className="reports_tablesectiontotal">
                                                <td>
                                                    <div>{data.name}</div>
                                                </td>
                                                <td>
                                                    <div>{data.currency + ' ' + data.amount.toLocaleString("en-US")}</div>
                                                </td>
                                            </tr>
                                        );
                                    }
                                    if (data.tabletype == 'group') {
                                        return (
                                            <tr key={"data" + index} className="reports_tablegroup">
                                                <td colSpan={2}>
                                                    <div>{data.name}</div>
                                                </td>
                                            </tr>
                                        );
                                    }
                                    if (data.tabletype == 'grouptotal') {
                                        return (
                                            <tr key={"data" + index} className="reports_tablegrouptotal">
                                                <td>
                                                    <div>{data.name}</div>
                                                </td>
                                                <td>
                                                    <div>{data.currency + ' ' + data.amount.toLocaleString("en-US")}</div>
                                                </td>
                                            </tr>
                                        );
                                    }
                                    if (data.tabletype == 'item') {
                                        return (
                                            <tr key={"data" + index} className="reports_tableitem">
                                                <td>
                                                    <div>{data.name}</div>
                                                </td>
                                                <td>
                                                    <div
                                                        className="reports_clickable"
                                                        onClick={() =>
                                                            handleAccountStatement(
                                                                data.type,
                                                                {
                                                                    id: data.accountid,
                                                                    name: data.name,
                                                                    from: fromts,
                                                                    to: tots,
                                                                    subaccountid: selectedsubaccountid,
                                                                    currencyid: selectedcurrencyid,
                                                                }
                                                            )
                                                        }
                                                    >
                                                        {data.currency + ' ' + data.amount.toLocaleString("en-US")}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    }
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    function BalanceSheet() {
        const [reportdata, setReportdata] = useState([]);

        const [selectedcurrencyid, setSelectedcurrencyid] = useState(project.basecurrency);

        const [loadingpdf, setLoadingpdf] = useState(false);
        const [resultpdf, setResultpdf] = useState('');

        const printRef = useRef();

        useEffect(() => {
            const context = {
                ...project,
                fromts: fromts,
                tots: tots,
                selectedcurrencyid: selectedcurrencyid,
            };

            const getbalancesheetreport = getbalancesheetreportdata(context)
            setReportdata(getbalancesheetreport)
        }, [fromts, tots, selectedcurrencyid]);

        const saveAsPDF = () => {
            setLoadingpdf(true);
            try {
                const projectName = project.name;

                const doc = new jsPDF();
                registerArabicFont(doc);

                const pageWidth = doc.internal.pageSize.getWidth();
                let currentY = 10;

                currentY += 10;
                doc.setFontSize(24);
                const title = 'Balance Sheet';
                const titleWidth = doc.getTextWidth(title);
                doc.text(title, (pageWidth - titleWidth) / 2, currentY);

                currentY += 10;
                doc.setFontSize(10);
                doc.text('Project Name: ' + project.name, 10, currentY);

                currentY += 5;
                const formattedFrom = moment.unix(fromts).format("D/MMM/YYYY");
                const formattedTo = moment.unix(tots).format("D/MMM/YYYY");
                doc.text('From: ' + formattedFrom, 10, currentY);
                currentY += 5;
                doc.text('To: ' + formattedTo, 10, currentY);

                currentY += 10;
                const tableColumn = ['Name', 'Amount'];

                const tableData = reportdata.map((data) => {
                    if (data.tabletype == 'section') return [
                        { content: data.name, colSpan: 2, styles: { fontStyle: 'bold' } }
                    ];
                    if (data.tabletype == 'item') return [
                        { content: data.name, styles: { fontStyle: 'normal', halign: 'left' } },
                        { content: data.currency + ' ' + data.amount.toLocaleString("en-US"), styles: { fontStyle: 'normal', halign: 'right' } }
                    ];
                });

                autoTable(doc, {
                    head: [tableColumn],
                    body: tableData,
                    startY: currentY,
                    theme: 'grid',
                    headStyles: {
                        fillColor: [200, 200, 200],
                        textColor: [0, 0, 0],
                        fontStyle: 'bold',
                    },
                    bodyStyles: {
                        fontSize: 10,
                        textColor: [0, 0, 0],
                        font: 'notoarabic',
                    },
                    columnStyles: {
                        0: { halign: 'left' },
                        1: { halign: 'left' },
                        2: { halign: 'left' },
                        3: { halign: 'left' },
                        4: { halign: 'left' },
                    },
                    margin: {
                        top: 10,
                        left: 10,
                        right: 10
                    },
                });

                const fileName = 'Trial Balance ' + projectName + '.pdf';
                doc.save(fileName.replace(/\s+/g, '_').toLowerCase());
                setResultpdf("Saved Successfully");
            } catch (error) {
                console.error('Error generating PDF:', error);
                setResultpdf("Error Saving PDF");
            } finally {
                setLoadingpdf(false);
            }
        };

        return (
            <div className='report'>
                <div className="reports_row">
                    <div className="reports_rowsection">
                        Currency
                    </div>
                    <div className="reports_rowsection">
                        <Select data={[{ id: '', name: 'All' }, ...project.currencies]} itemid={selectedcurrencyid} setItemid={setSelectedcurrencyid} />
                    </div>
                </div>
                <div className="reports_buttonscontainer">
                    <ReactToPrint
                        trigger={() => (<button className="reports_button">Print</button>)}
                        content={() => printRef.current}
                    />
                    <button className="reports_button" onClick={saveAsPDF}>
                        Save as PDF {loadingpdf && '(Loading...)'} {resultpdf && "(" + resultpdf + ")"}
                    </button>
                </div>
                <div className="reports_printable" ref={printRef}>
                    <div className="reports_headerrow">
                        <div className="reports_headercolleft">
                            {project.projectdetailsimage && (
                                <img
                                    className="reports_projectdetailsimage"
                                    src={project.projectdetailsimage}
                                    alt="Project Details Image"
                                />
                            )}
                        </div>
                        <div className="reports_headercolmiddle">
                            <div className="reports_title">Balance Sheet</div>
                            <div className="reports_projectname">{project.name}</div>
                            <div className="reports_dateframe">
                                {moment.unix(fromts).format("D/MMM/YYYY") + ' to ' + moment.unix(tots).format("D/MMM/YYYY")}
                            </div>
                        </div>
                        <div className="reports_headercolright"></div>
                    </div>
                    <table className="reports_table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                reportdata.map((data, index) => {
                                    if (data.tabletype == 'section') {
                                        return (
                                            <tr key={"data" + index} className="reports_tablesection">
                                                <td colSpan={2}>
                                                    <div>{data.name}</div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                    if (data.tabletype == 'item') {
                                        return (
                                            <tr key={"data" + index} className="reports_tableitem">
                                                <td>
                                                    <div>{data.name}</div>
                                                </td>
                                                <td>
                                                    <div>
                                                        {data.currency + ' ' + data.amount.toLocaleString("en-US")}
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    function CashFlow() {
        const [reportdata, setReportdata] = useState([]);

        const [selectedcurrencyid, setSelectedcurrencyid] = useState(project.basecurrency);
        const [selectedcashaccountid, setSelectedcashaccountid] = useState('');
        const [selectedsubaccountid, setSelectedsubaccountid] = useState('');

        const [loadingpdf, setLoadingpdf] = useState(false);
        const [resultpdf, setResultpdf] = useState('');

        const printRef = useRef();

        useEffect(() => {
            const context = {
                ...project,
                fromts: fromts,
                tots: tots,
                selectedcurrencyid: selectedcurrencyid,
                selectedcashaccountid: selectedcashaccountid,
                selectedsubaccountid: selectedsubaccountid,
            };

            const getcashflowstatement = getcashflowstatementdata(context)
            setReportdata(getcashflowstatement)
        }, [fromts, tots, selectedcashaccountid, selectedsubaccountid, selectedcurrencyid]);

        const saveAsPDF = () => {
            setLoadingpdf(true);
            try {
                const projectName = project.name;

                const doc = new jsPDF();
                registerArabicFont(doc);

                const pageWidth = doc.internal.pageSize.getWidth();
                let currentY = 10;

                currentY += 10;
                doc.setFontSize(24);
                const title = 'Cash Flow Statement';
                const titleWidth = doc.getTextWidth(title);
                doc.text(title, (pageWidth - titleWidth) / 2, currentY);

                currentY += 10;
                doc.setFontSize(10);
                doc.text('Project Name: ' + project.name, 10, currentY);

                currentY += 5;
                const formattedFrom = moment.unix(fromts).format("D/MMM/YYYY");
                const formattedTo = moment.unix(tots).format("D/MMM/YYYY");
                doc.text('From: ' + formattedFrom, 10, currentY);
                currentY += 5;
                doc.text('To: ' + formattedTo, 10, currentY);

                currentY += 5;
                const cashAccountName = project.cashaccounts.find(cash => cash.id === selectedcashaccountid)?.name || 'All';
                doc.text('Cash Account: ' + cashAccountName, 10, currentY);

                currentY += 5;
                const subAccountName = project.subaccounts.find(sub => sub.id === selectedsubaccountid)?.name || 'All';
                doc.text('Subaccount: ' + subAccountName, 10, currentY);

                currentY += 10;
                const tableColumn = ['Name', 'Amount'];

                const tableData = reportdata.map((data) => {
                    if (data.tabletype == 'section') return [
                        { content: data.name, colSpan: 2, styles: { fontStyle: 'bold' } },
                    ];
                    if (data.tabletype == 'sectiontotal') return [
                        { content: data.name, styles: { fontStyle: 'bold' } },
                        { content: data.currency + ' ' + data.amount.toLocaleString("en-US"), styles: { fontStyle: 'bold' } },
                    ];
                    if (data.tabletype == 'group') return [
                        { content: data.name, styles: { fontStyle: 'normal' } },
                        { content: data.currency + ' ' + data.amount.toLocaleString("en-US"), styles: { fontStyle: 'normal' } },
                    ];
                    if (data.tabletype == 'grouptotal') return [
                        { content: data.name, styles: { fontStyle: 'normal' } },
                        { content: data.currency + ' ' + data.amount.toLocaleString("en-US"), styles: { fontStyle: 'normal' } },
                    ];
                    if (data.tabletype == 'item') return [
                        { content: data.name, styles: { fontStyle: 'normal' } },
                        { content: data.currency + ' ' + data.amount.toLocaleString("en-US"), styles: { fontStyle: 'normal' } },
                    ];
                });

                autoTable(doc, {
                    head: [tableColumn],
                    body: tableData,
                    startY: currentY,
                    theme: 'grid',
                    headStyles: {
                        fillColor: [200, 200, 200],
                        textColor: [0, 0, 0],
                        fontStyle: 'bold',
                    },
                    bodyStyles: {
                        fontSize: 10,
                        textColor: [0, 0, 0],
                        font: 'notoarabic',
                    },
                    columnStyles: {
                        0: { halign: 'left' },
                        1: { halign: 'right' },
                    },
                    margin: {
                        top: 10,
                        left: 10,
                        right: 10
                    },
                });

                const fileName = 'Cash Flow Statement ' + projectName + '.pdf';
                doc.save(fileName.replace(/\s+/g, '_').toLowerCase());
                setResultpdf("Saved Successfully");
            } catch (error) {
                console.error('Error generating PDF:', error);
                setResultpdf("Error Saving PDF");
            } finally {
                setLoadingpdf(false);
            }
        };

        return (
            <div className="report">
                <div className="reports_row">
                    <div className="reports_rowsection">
                        Currency
                    </div>
                    <div className="reports_rowsection">
                        <Select data={project.currencies} itemid={selectedcurrencyid} setItemid={setSelectedcurrencyid} />
                    </div>
                    <div className="reports_rowsection">
                        Cash Account
                    </div>
                    <div className="reports_rowsection">
                        <Select data={[{ id: '', name: 'All' }, ...project.cashaccounts]} itemid={selectedcashaccountid} setItemid={setSelectedcashaccountid} />
                    </div>
                    <div className="reports_rowsection">
                        Subaccount
                    </div>
                    <div className="reports_rowsection">
                        <Select data={[{ id: '', name: 'All' }, ...project.subaccounts]} itemid={selectedsubaccountid} setItemid={setSelectedsubaccountid} />
                    </div>
                </div>
                <div className="reports_buttonscontainer">
                    <ReactToPrint
                        trigger={() => (<button className="reports_button">Print</button>)}
                        content={() => printRef.current}
                    />
                    <button className="reports_button" onClick={saveAsPDF}>
                        Save as PDF {loadingpdf && '(Loading...)'} {resultpdf && "(" + resultpdf + ")"}
                    </button>
                </div>
                <div className="reports_printable" ref={printRef}>
                    <div className="reports_headerrow">
                        <div className="reports_headercolleft">
                            {project.projectdetailsimage && (
                                <img
                                    className="reports_projectdetailsimage"
                                    src={project.projectdetailsimage}
                                    alt="Project Details Image"
                                />
                            )}
                        </div>
                        <div className="reports_headercolmiddle">
                            <div className="reports_title">Cash Flow Statement</div>
                            <div className="reports_projectname">{project.name}</div>
                            <div className="reports_projectdetails">Cash Account: {project.cashaccounts.find((cash) => cash.id === selectedcashaccountid)?.name || 'All'}, Subaccount: {project.subaccounts.find((sub) => sub.id === selectedsubaccountid)?.name || 'All'}</div>
                            <div className="reports_dateframe">
                                {moment.unix(fromts).format("D/MMM/YYYY") + ' to ' + moment.unix(tots).format("D/MMM/YYYY")}
                            </div>
                        </div>
                        <div className="reports_headercolright"></div>
                    </div>
                    <table className="reports_table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                reportdata
                                    .map((data, index) => {
                                        if (data.tabletype == 'section') {
                                            return (
                                                <tr key={"data" + index} className="reports_tablesection">
                                                    <td colSpan={2}><div>{data.name}</div></td>
                                                </tr>
                                            )
                                        }
                                        if (data.tabletype == 'sectiontotal') {
                                            return (
                                                <tr key={"data" + index} className="reports_tablesectiontotal">
                                                    <td><div>{data.name}</div></td>
                                                    <td><div>{data.currency + ' ' + data.amount.toLocaleString("en-US")}</div></td>
                                                </tr>
                                            )
                                        }
                                        if (data.tabletype == 'group') {
                                            return (
                                                <tr key={"data" + index} className='reports_tablegroup'>
                                                    <td><div>{data.name}</div></td>
                                                    <td><div>{data.currency + ' ' + data.amount.toLocaleString("en-US")}</div></td>
                                                </tr>
                                            );
                                        }
                                        if (data.tabletype == 'grouptotal') {
                                            return (
                                                <tr key={"data" + index} className='reports_tablegrouptotal'>
                                                    <td><div>{data.name}</div></td>
                                                    <td><div>{data.currency + ' ' + data.amount.toLocaleString("en-US")}</div></td>
                                                </tr>
                                            );
                                        }
                                        if (data.tabletype == 'item') {
                                            return (
                                                <tr key={"data" + index} className="reports_tableitem">
                                                    <td>
                                                        <div>{data.name}</div>
                                                    </td>
                                                    <td>
                                                        <div>
                                                            {data.currency + ' ' + data.amount.toLocaleString("en-US")}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    function TrialBalance() {
        const [selectedcoa, setSelectedcoa] = useState('lebanon');
        const [basis, setBasis] = useState('accrual');
        const [togglezerovalues, setTogglezerovalues] = useState(false);
        const [selectedcurrency, setSelectedcurrency] = useState(project.basecurrency);
        const [trialbalance, setTrialbalance] = useState([]);

        const [loadingpdf, setLoadingpdf] = useState(false);
        const [resultpdf, setResultpdf] = useState('');

        const printRef = useRef();

        const context = {
            assets: project.assets,
            cashaccounts: project.cashaccounts,
            items: project.items,
            transactions: project.transactions,
            interaccounttransfers: project.interaccounttransfers,
            clients: project.clients,
            salesinvoices: project.salesinvoices,
            journalentries: project.journalentries,
            suppliers: project.suppliers,
            staff: project.staff,
            payslips: project.payslips,
            purchaseinvoices: project.purchaseinvoices,
            assetgroups: project.assetgroups,
            assetaccounts: project.assetaccounts,
            liabilitygroups: project.liabilitygroups,
            liabilityaccounts: project.liabilityaccounts,
            equityaccounts: project.equityaccounts,
            equitygroups: project.equitygroups,
            incomegroups: project.incomegroups,
            incomeaccounts: project.incomeaccounts,
            expenseaccounts: project.expenseaccounts,
            expensegroups: project.expensegroups,
            exchangerates: project.exchangerates,
            currencies: project.currencies,
        };

        useEffect(() => {
            const trial = getTrialbalance(context, fromts, tots, selectedcoa, selectedcurrency, basis, project.basecurrency)
            setTrialbalance(trial)
        }, [selectedcoa, basis, selectedcurrency]);

        const saveAsPDF = () => {
            setLoadingpdf(true);
            try {
                const projectName = project.name;

                const doc = new jsPDF();
                registerArabicFont(doc);

                const pageWidth = doc.internal.pageSize.getWidth();
                let currentY = 10;

                currentY += 10;
                doc.setFontSize(24);
                const title = 'Trial Balance';
                const titleWidth = doc.getTextWidth(title);
                doc.text(title, (pageWidth - titleWidth) / 2, currentY);

                currentY += 10;
                doc.setFontSize(10);
                doc.text('Project Name: ' + project.name, 10, currentY);

                currentY += 5;
                const formattedFrom = moment.unix(fromts).format("D/MMM/YYYY");
                const formattedTo = moment.unix(tots).format("D/MMM/YYYY");
                doc.text('From: ' + formattedFrom, 10, currentY);
                currentY += 5;
                doc.text('To: ' + formattedTo, 10, currentY);

                currentY += 10;
                const tableColumn = ['ID', 'Name', 'Debit', 'Credit', 'Balance'];

                const tableData = trialbalance.flatMap((data) => {
                    if (data.tabletype === 'group') {
                        return [
                            [
                                { content: data.orderid, styles: { fontStyle: 'bold', halign: 'left' } },
                                { content: data.name, colSpan: 4, styles: { fontStyle: 'bold', halign: 'left' } },
                            ]
                        ];
                    }
                    else if (data.tabletype === 'item') {
                        return [
                            [
                                { content: data.orderid, styles: { fontStyle: 'normal', halign: 'left' } },
                                { content: data.name, styles: { fontStyle: 'normal', halign: 'left' } },
                                { content: (data.currencysymbol || '') + ' ' + data.debit.toLocaleString("en-US"), styles: { fontStyle: 'normal', halign: 'right' } },
                                { content: (data.currencysymbol || '') + ' ' + data.credit.toLocaleString("en-US"), styles: { fontStyle: 'normal', halign: 'right' } },
                                { content: (data.currencysymbol || '') + ' ' + data.balance.toLocaleString("en-US"), styles: { fontStyle: 'normal', halign: 'right' } },
                            ]
                        ];
                    }
                    return [];
                });


                autoTable(doc, {
                    head: [tableColumn],
                    body: tableData,
                    startY: currentY,
                    theme: 'grid',
                    headStyles: {
                        fillColor: [200, 200, 200],
                        textColor: [0, 0, 0],
                        fontStyle: 'bold',
                    },
                    bodyStyles: {
                        fontSize: 10,
                        textColor: [0, 0, 0],
                        font: 'notoarabic',
                    },
                    columnStyles: {
                        0: { halign: 'left' },
                        1: { halign: 'left' },
                        2: { halign: 'left' },
                        3: { halign: 'left' },
                        4: { halign: 'left' },
                    },
                    margin: {
                        top: 10,
                        left: 10,
                        right: 10
                    },
                });

                const fileName = 'Trial Balance ' + projectName + '.pdf';
                doc.save(fileName.replace(/\s+/g, '_').toLowerCase());
                setResultpdf("Saved Successfully");
            } catch (error) {
                console.error('Error generating PDF:', error);
                setResultpdf("Error Saving PDF");
            } finally {
                setLoadingpdf(false);
            }
        };

        return (
            <div className='report'>
                <div className="reports_row">
                    <div className="reports_rowsection">
                        Chart Account
                    </div>
                    <div className="reports_rowsection">
                        <Select data={countryCoa} itemid={selectedcoa} setItemid={setSelectedcoa} />
                    </div>
                    <div className="reports_rowsection">
                        Method
                    </div>
                    <div className="reports_rowsection">
                        <Select data={basisTypes} itemid={basis} setItemid={setBasis} />
                    </div>
                    <div className="reports_rowsection">
                        Exclude Zero Values
                    </div>
                    <div className="reports_rowsection">
                        <label className="toggle_switch">
                            <input
                                type="checkbox"
                                checked={togglezerovalues}
                                onChange={() => setTogglezerovalues(!togglezerovalues)}
                            />
                        </label>
                    </div>
                    <div className="reports_rowsection">
                        Currency
                    </div>
                    <div className="reports_rowsection">
                        <Select data={[{ id: '', name: 'All' }, ...project.currencies]} itemid={selectedcurrency} setItemid={setSelectedcurrency} />
                    </div>
                </div>
                <div className="reports_buttonscontainer">
                    <ReactToPrint
                        trigger={() => (<button className="reports_button">Print</button>)}
                        content={() => printRef.current}
                    />
                    <button className="reports_button" onClick={saveAsPDF}>
                        Save as PDF {loadingpdf && '(Loading...)'} {resultpdf && "(" + resultpdf + ")"}
                    </button>
                </div>
                <div className="reports_printable" ref={printRef}>
                    <div className="reports_headerrow">
                        <div className="reports_headercolleft">
                            {project.projectdetailsimage && (
                                <img
                                    className="reports_projectdetailsimage"
                                    src={project.projectdetailsimage}
                                    alt="Project Details Image"
                                />
                            )}
                        </div>
                        <div className="reports_headercolmiddle">
                            <div className="reports_title">Trial Balance</div>
                            <div className="reports_projectname">{project.name}</div>
                            <div className="reports_dateframe">
                                {moment.unix(fromts).format("D/MMM/YYYY") + ' to ' + moment.unix(tots).format("D/MMM/YYYY")}
                            </div>
                        </div>
                        <div className="reports_headercolright"></div>
                    </div>
                    <table className="reports_table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Debit</th>
                                <th>Credit</th>
                                <th>Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                trialbalance.map((item, index) => {
                                    if (item.type == 'group') {
                                        return (
                                            <tr
                                                key={"account" + index}
                                                className="reports_tablegroup"
                                            >
                                                <td><div>{item.orderid}</div></td>
                                                <td colSpan={4}><div>{item.name}</div></td>
                                            </tr>
                                        )
                                    }
                                    if (item.type == 'item') {
                                        return (
                                            <tr
                                                key={"account" + index}
                                                className="reports_tableitem"
                                            >
                                                <td><div>{item.orderid}</div></td>
                                                <td><div>{item.name}</div></td>
                                                <td><div>{item.currencysymbol + ' ' + item.debit.toLocaleString("en-US")}</div></td>
                                                <td><div>{item.currencysymbol + ' ' + item.credit.toLocaleString("en-US")}</div></td>
                                                <td>
                                                    <div
                                                        className="reports_clickable"
                                                        onClick={() =>
                                                            handleAccountStatement(
                                                                item.accounttype,
                                                                {
                                                                    id: item.id,
                                                                    name: item.name,
                                                                    from: fromts,
                                                                    to: tots,
                                                                    cashaccountid: 0,
                                                                    subaccountid: 0,
                                                                    currencyid: project.basecurrency,
                                                                }
                                                            )
                                                        }
                                                    >
                                                        {item.currencysymbol + ' ' + item.balance.toLocaleString("en-US")}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    }
                                    if (item.type == 'total') {
                                        return (
                                            <tr
                                                key={"account" + index}
                                                className="reports_tableitem"
                                            >
                                                <td><div>{item.orderid}</div></td>
                                                <td><div>{item.name}</div></td>
                                                <td><div>{item.currencysymbol + ' ' + item.debit.toLocaleString("en-US")}</div></td>
                                                <td><div>{item.currencysymbol + ' ' + item.credit.toLocaleString("en-US")}</div></td>
                                                <td><div>{item.currencysymbol + ' ' + item.balance.toLocaleString("en-US")}</div>
                                                </td>
                                            </tr>
                                        );
                                    }
                                })}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    function InvoicesReport() {
        const [reportdata, setReportdata] = useState([]);

        const [selectedcurrencyid, setSelectedcurrencyid] = useState(project.basecurrency);
        const [selectedsubaccountid, setSelectedsubaccountid] = useState('');

        const [loadingpdf, setLoadingpdf] = useState(false);
        const [resultpdf, setResultpdf] = useState('');

        const printRef = useRef();

        useEffect(() => {
            const context = {
                ...project,
                fromts: fromts,
                tots: tots,
                selectedcurrencyid: selectedcurrencyid
            };

            const getinvoicesreport = getinvoicesreportdata(context)

            setReportdata(getinvoicesreport)
        }, [fromts, tots, selectedcurrencyid]);

        const saveAsPDF = () => {
            setLoadingpdf(true);
            try {
                const projectName = project.name;

                const doc = new jsPDF();
                registerArabicFont(doc);

                const pageWidth = doc.internal.pageSize.getWidth();
                let currentY = 10;

                currentY += 10;
                doc.setFontSize(24);
                const title = 'Items Report';
                const titleWidth = doc.getTextWidth(title);
                doc.text(title, (pageWidth - titleWidth) / 2, currentY);

                currentY += 10;
                doc.setFontSize(10);
                doc.text('Project Name: ' + project.name, 10, currentY);

                currentY += 5;
                const formattedFrom = moment.unix(fromts).format("D/MMM/YYYY");
                const formattedTo = moment.unix(tots).format("D/MMM/YYYY");
                doc.text('From: ' + formattedFrom, 10, currentY);
                currentY += 5;
                doc.text('To: ' + formattedTo, 10, currentY);

                currentY += 10;
                const tableColumn = ['Date', 'Client', 'Name', 'Amount', 'Subaccount'];

                const tableData = reportdata.map((data) => {
                    if (data.tabletype == 'item') return [
                        { content: data.date, styles: { fontStyle: 'normal' } },
                        { content: data.accountname, styles: { fontStyle: 'normal' } },
                        { content: data.name, styles: { fontStyle: 'normal' } },
                        { content: data.currency + ' ' + data.amount.toLocaleString("en-US"), styles: { fontStyle: 'normal' } },
                        { content: data.subaccount, styles: { fontStyle: 'normal' } },
                    ];
                    if (data.tabletype == 'sectiontotal') return [
                        { content: data.name, colSpan: 3, styles: { fontStyle: 'bold' } },
                        { content: data.currency + ' ' + data.amount.toLocaleString("en-US"), styles: { fontStyle: 'bold' } },
                        { content: '', styles: { fontStyle: 'bold' } },
                    ];
                });

                autoTable(doc, {
                    head: [tableColumn],
                    body: tableData,
                    startY: currentY,
                    theme: 'grid',
                    headStyles: {
                        fillColor: [200, 200, 200],
                        textColor: [0, 0, 0],
                        fontStyle: 'bold',
                    },
                    bodyStyles: {
                        fontSize: 10,
                        textColor: [0, 0, 0],
                        font: 'notoarabic',
                    },
                    columnStyles: {
                        0: { halign: 'left' },
                        1: { halign: 'left' },
                        2: { halign: 'left' },
                        3: { halign: 'left' },
                        4: { halign: 'left' },
                    },
                    margin: {
                        top: 10,
                        left: 10,
                        right: 10
                    },
                });

                const fileName = 'Items Report ' + projectName + '.pdf';
                doc.save(fileName.replace(/\s+/g, '_').toLowerCase());
                setResultpdf("Saved Successfully");
            } catch (error) {
                console.error('Error generating PDF:', error);
                setResultpdf("Error Saving PDF");
            } finally {
                setLoadingpdf(false);
            }
        };

        return (
            <div className="report">
                <div className="reports_row">
                    <div className="reports_rowsection">
                        Currency
                    </div>
                    <div className="reports_rowsection">
                        <Select data={project.currencies} itemid={selectedcurrencyid} setItemid={setSelectedcurrencyid} />
                    </div>
                    <div className="reports_rowsection">
                        Subaccount
                    </div>
                    <div className="reports_rowsection">
                        <Select data={[{ id: '', name: 'All' }, ...project.subaccounts]} itemid={selectedsubaccountid} setItemid={setSelectedsubaccountid} />
                    </div>
                </div>
                <div className="reports_buttonscontainer">
                    <ReactToPrint
                        trigger={() => (<button className="reports_button">Print</button>)}
                        content={() => printRef.current}
                    />
                    <button className="reports_button" onClick={saveAsPDF}>
                        Save as PDF {loadingpdf && '(Loading...)'} {resultpdf && "(" + resultpdf + ")"}
                    </button>
                </div>
                <div className="reports_printable" ref={printRef}>
                    <div className="reports_headerrow">
                        <div className="reports_headercolleft">
                            {project.projectdetailsimage && (
                                <img
                                    className="reports_projectdetailsimage"
                                    src={project.projectdetailsimage}
                                    alt="Project Details Image"
                                />
                            )}
                        </div>
                        <div className="reports_headercolmiddle">
                            <div className="reports_title">Invoices Report</div>
                            <div className="reports_projectname">{project.name}</div>
                            <div className="reports_dateframe">
                                {moment.unix(fromts).format("D/MMM/YYYY") + ' to ' + moment.unix(tots).format("D/MMM/YYYY")}
                            </div>
                        </div>
                        <div className="reports_headercolright"></div>
                    </div>
                    <table className="reports_table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Client</th>
                                <th>Name</th>
                                <th>Amount</th>
                                <th>Subaccount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                reportdata.map((data, index) => {
                                    if (data.tabletype == 'item') {
                                        return (
                                            <tr key={"data" + index}>
                                                <td><div>{data.date}</div></td>
                                                <td><div>{data.accountname}</div></td>
                                                <td><div>{data.name}</div></td>
                                                <td><div>{data.currency + ' ' + data.amount.toLocaleString("en-US")}</div></td>
                                                <td><div>{data.subaccount}</div></td>
                                            </tr>
                                        );
                                    }
                                    if (data.tabletype == 'sectiontotal') {
                                        return (
                                            <tr key={"data" + index} className='reports_tablesectiontotal'>
                                                <td colSpan={3}><div>{data.name}</div></td>
                                                <td><div>{data.currency + ' ' + data.amount.toLocaleString("en-US")}</div></td>
                                                <td><div></div></td>
                                            </tr>
                                        );
                                    }
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    function ItemsQuantity() {
        const printRef = useRef();

        const [loadingpdf, setLoadingpdf] = useState(false);
        const [resultpdf, setResultpdf] = useState('');

        const context = {
            ...project,
            fromts: fromts,
            tots: tots,
        };

        const itemsdata = getItemsQuantityData(context);
        console.log(itemsdata)
        const saveAsPDF = () => {
            setLoadingpdf(true);
            try {
                const projectName = project.name;

                const doc = new jsPDF();
                registerArabicFont(doc);

                const pageWidth = doc.internal.pageSize.getWidth();
                let currentY = 10;

                currentY += 10;
                doc.setFontSize(24);
                const title = 'Items Report';
                const titleWidth = doc.getTextWidth(title);
                doc.text(title, (pageWidth - titleWidth) / 2, currentY);

                currentY += 10;
                doc.setFontSize(10);
                doc.text('Project Name: ' + project.name, 10, currentY);

                currentY += 5;
                const formattedFrom = moment.unix(fromts).format("D/MMM/YYYY");
                const formattedTo = moment.unix(tots).format("D/MMM/YYYY");
                doc.text('From: ' + formattedFrom, 10, currentY);
                currentY += 5;
                doc.text('To: ' + formattedTo, 10, currentY);

                currentY += 10;
                const tableColumn = ['Code', 'Name', 'Purchased', 'Sold', 'Remaining'];

                const tableData = itemsdata.map((data) => {
                    if (data.tabletype == 'account') return [
                        { content: data.code, styles: { fontStyle: 'normal' } },
                        { content: data.name, styles: { fontStyle: 'normal' } },
                        { content: data.purchased, styles: { fontStyle: 'normal' } },
                        { content: data.sold, styles: { fontStyle: 'normal' } },
                        { content: data.remaining, styles: { fontStyle: 'normal' } },
                    ];
                    if (data.tabletype == 'total') return [
                        { content: data.name, colSpan: 2, styles: { fontStyle: 'bold' } },
                        { content: data.purchased, styles: { fontStyle: 'bold' } },
                        { content: data.sold, styles: { fontStyle: 'bold' } },
                        { content: data.remaining, styles: { fontStyle: 'bold' } },
                    ];
                });

                autoTable(doc, {
                    head: [tableColumn],
                    body: tableData,
                    startY: currentY,
                    theme: 'grid',
                    headStyles: {
                        fillColor: [200, 200, 200],
                        textColor: [0, 0, 0],
                        fontStyle: 'bold',
                    },
                    bodyStyles: {
                        fontSize: 10,
                        textColor: [0, 0, 0],
                        font: 'notoarabic',
                    },
                    columnStyles: {
                        0: { halign: 'left' },
                        1: { halign: 'left' },
                        2: { halign: 'left' },
                        3: { halign: 'left' },
                        4: { halign: 'left' },
                    },
                    margin: {
                        top: 10,
                        left: 10,
                        right: 10
                    },
                });

                const fileName = 'Items Report ' + projectName + '.pdf';
                doc.save(fileName.replace(/\s+/g, '_').toLowerCase());
                setResultpdf("Saved Successfully");
            } catch (error) {
                console.error('Error generating PDF:', error);
                setResultpdf("Error Saving PDF");
            } finally {
                setLoadingpdf(false);
            }
        };

        return (
            <div className="report">
                <div className="reports_buttonscontainer">
                    <ReactToPrint
                        trigger={() => (<button className="reports_button">Print</button>)}
                        content={() => printRef.current}
                    />
                    <button className="reports_button" onClick={saveAsPDF}>
                        Save as PDF {loadingpdf && '(Loading...)'} {resultpdf && "(" + resultpdf + ")"}
                    </button>
                </div>
                <div className="reports_printable" ref={printRef}>
                    <div className="reports_headerrow">
                        <div className="reports_headercolleft">
                            {project.projectdetailsimage && (
                                <img
                                    className="reports_projectdetailsimage"
                                    src={project.projectdetailsimage}
                                    alt="Project Details Image"
                                />
                            )}
                        </div>
                        <div className="reports_headercolmiddle">
                            <div className="reports_title">Items Report</div>
                            <div className="reports_projectname">{project.name}</div>
                            <div className="reports_dateframe">
                                {moment.unix(fromts).format("D/MMM/YYYY") + ' to ' + moment.unix(tots).format("D/MMM/YYYY")}
                            </div>
                        </div>
                        <div className="reports_headercolright"></div>
                    </div>
                    <table className="reports_table">
                        <thead>
                            <tr>
                                <th>Code</th>
                                <th>Name</th>
                                <th>Purchased</th>
                                <th>Sold</th>
                                <th>Remaining</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                itemsdata.map((data, index) => {
                                    if (data.tabletype == 'item') return (
                                        <tr
                                            key={"data" + index}
                                        >
                                            <td>
                                                <div>{data.code}</div>
                                            </td>
                                            <td>
                                                <div>{data.name}</div>
                                            </td>
                                            <td>
                                                <div>
                                                    {data.purchased}
                                                </div>
                                            </td>
                                            <td>
                                                <div >
                                                    {data.sold}
                                                </div>
                                            </td>
                                            <td>
                                                <div
                                                    className='reports_clickable'
                                                    onClick={() =>
                                                        handleAccountStatement(
                                                            'items',
                                                            {
                                                                id: data.id,
                                                                name: data.name,
                                                                from: Math.floor(new Date(new Date(project.startdate * 1000).setHours(0, 0, 0, 0)).getTime() / 1000),
                                                                to: Math.floor(new Date().setHours(23, 59, 59, 999) / 1000),
                                                                subaccountid: 0,
                                                                currencyid: project.basecurrency
                                                            }
                                                        )}
                                                >
                                                    {data.remaining}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                    if (data.tabletype == 'sectiontotal') return (
                                        <tr
                                            key={"data" + index}
                                            className='reports_tablesectiontotal'
                                        >
                                            <td colSpan={2}>
                                                <div>{data.name}</div>
                                            </td>
                                            <td>
                                                <div>
                                                    {data.purchased}
                                                </div>
                                            </td>
                                            <td>
                                                <div >
                                                    {data.sold}
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    {data.remaining}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    function ItemsValue() {
        const printRef = useRef();

        const [loadingpdf, setLoadingpdf] = useState(false);
        const [resultpdf, setResultpdf] = useState('');

        const context = {
            items: project.items,
            purchaseinvoices: project.purchaseinvoices,
            salesinvoices: project.salesinvoices,
            exchangerates: project.exchangerates,
            currencies: project.currencies,
            basecurrency: project.basecurrency,
            fromts: fromts,
            tots: tots,
        };

        const itemsdata = getItemsValueData(context);

        const saveAsPDF = () => {
            setLoadingpdf(true);
            try {
                const projectName = project.name;

                const doc = new jsPDF();
                registerArabicFont(doc);

                const pageWidth = doc.internal.pageSize.getWidth();
                let currentY = 10;

                currentY += 10;
                doc.setFontSize(24);
                const title = 'Items Report';
                const titleWidth = doc.getTextWidth(title);
                doc.text(title, (pageWidth - titleWidth) / 2, currentY);

                currentY += 10;
                doc.setFontSize(10);
                doc.text('Project Name: ' + project.name, 10, currentY);

                currentY += 5;
                const formattedFrom = moment.unix(fromts).format("D/MMM/YYYY");
                const formattedTo = moment.unix(tots).format("D/MMM/YYYY");
                doc.text('From: ' + formattedFrom, 10, currentY);
                currentY += 5;
                doc.text('To: ' + formattedTo, 10, currentY);

                currentY += 10;
                const tableColumn = ['Code', 'Name', 'Purchased', 'Sold', 'Profit', 'Margin'];

                const tableData = itemsdata.map((data) => {
                    if (data.tabletype == 'account') return [
                        { content: data.code, styles: { fontStyle: 'normal' } },
                        { content: data.name, styles: { fontStyle: 'normal' } },
                        { content: data.currency + ' ' + data.purchased.toLocaleString("en-US"), styles: { fontStyle: 'normal' } },
                        { content: data.currency + ' ' + data.sold.toLocaleString("en-US"), styles: { fontStyle: 'normal' } },
                        { content: data.currency + ' ' + data.profit.toLocaleString("en-US"), styles: { fontStyle: 'normal' } },
                        { content: data.margin, styles: { fontStyle: 'normal' } },
                    ];
                    if (data.tabletype == 'total') return [
                        { content: data.name, colSpan: 2, styles: { fontStyle: 'bold' } },
                        { content: data.currency + ' ' + data.purchased.toLocaleString("en-US"), styles: { fontStyle: 'bold' } },
                        { content: data.currency + ' ' + data.sold.toLocaleString("en-US"), styles: { fontStyle: 'bold' } },
                        { content: data.currency + ' ' + data.profit.toLocaleString("en-US"), styles: { fontStyle: 'bold' } },
                        { content: data.margin, styles: { fontStyle: 'bold' } },
                    ];
                });

                autoTable(doc, {
                    head: [tableColumn],
                    body: tableData,
                    startY: currentY,
                    theme: 'grid',
                    headStyles: {
                        fillColor: [200, 200, 200],
                        textColor: [0, 0, 0],
                        fontStyle: 'bold',
                    },
                    bodyStyles: {
                        fontSize: 10,
                        textColor: [0, 0, 0],
                        font: 'notoarabic',
                    },
                    columnStyles: {
                        0: { halign: 'left' },
                        1: { halign: 'left' },
                        2: { halign: 'left' },
                        3: { halign: 'left' },
                        4: { halign: 'left' },
                        5: { halign: 'left' },
                    },
                    margin: {
                        top: 10,
                        left: 10,
                        right: 10
                    },
                });

                const fileName = 'Items Report ' + projectName + '.pdf';
                doc.save(fileName.replace(/\s+/g, '_').toLowerCase());
                setResultpdf("Saved Successfully");
            } catch (error) {
                console.error('Error generating PDF:', error);
                setResultpdf("Error Saving PDF");
            } finally {
                setLoadingpdf(false);
            }
        };

        return (
            <div className="report">
                <div className="reports_buttonscontainer">
                    <ReactToPrint
                        trigger={() => (<button className="reports_button">Print</button>)}
                        content={() => printRef.current}
                    />
                    <button className="reports_button" onClick={saveAsPDF}>
                        Save as PDF {loadingpdf && '(Loading...)'} {resultpdf && "(" + resultpdf + ")"}
                    </button>
                </div>
                <div className="reports_printable" ref={printRef}>
                    <div className="reports_headerrow">
                        <div className="reports_headercolleft">
                            {project.projectdetailsimage && (
                                <img
                                    className="reports_projectdetailsimage"
                                    src={project.projectdetailsimage}
                                    alt="Project Details Image"
                                />
                            )}
                        </div>
                        <div className="reports_headercolmiddle">
                            <div className="reports_title">Items Report</div>
                            <div className="reports_projectname">{project.name}</div>
                            <div className="reports_dateframe">
                                {moment.unix(fromts).format("D/MMM/YYYY") + ' to ' + moment.unix(tots).format("D/MMM/YYYY")}
                            </div>
                        </div>
                        <div className="reports_headercolright"></div>
                    </div>
                    <table className="reports_table">
                        <thead>
                            <tr>
                                <th>Code</th>
                                <th>Name</th>
                                <th>Purchased</th>
                                <th>Sold</th>
                                <th>Profit</th>
                                <th>Margin</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                itemsdata.map((data, index) => {
                                    if (data.tabletype == 'item') return (
                                        <tr
                                            key={"data" + index}
                                        >
                                            <td>
                                                <div>{data.code}</div>
                                            </td>
                                            <td>
                                                <div>{data.name}</div>
                                            </td>
                                            <td>
                                                <div>{data.currency + ' ' + data.purchased.toLocaleString("en-US")}</div>
                                            </td>
                                            <td>
                                                <div>{data.currency + ' ' + data.sold.toLocaleString("en-US")}</div>
                                            </td>
                                            <td>
                                                <div>{data.currency + ' ' + data.profit.toLocaleString("en-US")}</div>
                                            </td>
                                            <td>
                                                <div>{data.margin}</div>
                                            </td>
                                        </tr>
                                    );
                                    if (data.tabletype == 'sectiontotal') return (
                                        <tr
                                            key={"data" + index}
                                            className='reports_tablesectiontotal'
                                        >
                                            <td colSpan={2}>
                                                <div>{data.name}</div>
                                            </td>
                                            <td>
                                                <div>{data.currency + ' ' + data.purchased.toLocaleString("en-US")}</div>
                                            </td>
                                            <td>
                                                <div>{data.currency + ' ' + data.sold.toLocaleString("en-US")}</div>
                                            </td>
                                            <td>
                                                <div>{data.currency + ' ' + data.profit.toLocaleString("en-US")}</div>
                                            </td>
                                            <td>
                                                <div>{data.margin}</div>
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    function OverallReport() {
        const [loadingpdf, setLoadingpdf] = useState(false);
        const [resultpdf, setResultpdf] = useState('');

        const initializeVisibility = () => ({
            cashaccounts: { visible: true, name: "Cash Accounts", disabled: false },
            cashflowstatement: { visible: true, name: "Cash Flow Statement", disabled: false },
            profitloss: { visible: true, name: "Profit & Loss", disabled: false },
            clientbalances: { visible: true, name: "Client Balances", disabled: false },
            collections: { visible: true, name: "Collections", disabled: false },
            payments: { visible: true, name: "Payments", disabled: false },
            liabilities: { visible: true, name: "Liabilities", disabled: false },
            suppliers: { visible: true, name: "Suppliers", disabled: false },
            staff: { visible: true, name: "Staff", disabled: false },
            assets: { visible: true, name: "Assets", disabled: false },
        });

        const [visibility, setVisibility] = useState(() => initializeVisibility(project));

        const printRef = useRef();

        const context = {
            ...project,
            cashaccountid: '',
            subaccountid: '',
            fromts: fromts,
            tots: tots,
            zerobalances: false
        };

        const cashaccountsdata = getCashAccounts(context);

        const [filteredclientscolumnheader, setFilteredclientscolumnheader] = useState([]);
        const [filteredclientscolumnrows, setFilteredclientscolumnrows] = useState([]);
        const [filteredclientscolumnfooter, setFilteredclientscolumnfooter] = useState([]);

        useEffect(() => {
            const clientsdatacolumn = getClientBalancesColumn(context);

            setFilteredclientscolumnheader(clientsdatacolumn.header);
            setFilteredclientscolumnrows(clientsdatacolumn.rows);
            setFilteredclientscolumnfooter(clientsdatacolumn.footer);
        }, []);

        const [collections, setCollections] = useState([]);
        useEffect(() => {
            const data = {
                projectuserid: project.projectuserid,
                projectid: project.projectid
            };

            axios.post(configData.CONTROLLERURL + configData.GETCOLLECTIONS, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                if (res.data instanceof Array) {
                    setCollections(res.data);
                }
            }).catch((err) => {
            }).finally(() => {
            });
        }, []);

        const saveAsPDF = async () => {
            setLoadingpdf(true);
            try {
                const doc = new jsPDF();
                registerArabicFont(doc);

                const pageWidth = doc.internal.pageSize.getWidth();
                let currentY = 10;

                currentY += 10;
                doc.setFontSize(24);
                const title = 'Report';
                const titleWidth = doc.getTextWidth(title);
                doc.text(title, (pageWidth - titleWidth) / 2, currentY);

                currentY += 10;
                doc.setFontSize(14);
                const projectName = project.name;
                const projectnameWidth = doc.getTextWidth(projectName);
                doc.text(projectName, (pageWidth - projectnameWidth) / 2, currentY);

                currentY += 5;
                doc.setFontSize(10);
                const formattedFrom = moment.unix(fromts).format("D/MMM/YYYY");
                const formattedTo = moment.unix(tots).format("D/MMM/YYYY");
                const daterangeWidth = doc.getTextWidth(formattedFrom + ' to ' + formattedTo);
                doc.text(formattedFrom + ' to ' + formattedTo, (pageWidth - daterangeWidth) / 2, currentY);

                if (visibility.cashaccounts.visible) {
                    currentY += 10;
                    doc.setFontSize(20);
                    const chapter = 'Cash Accounts';
                    const chapterWidth = doc.getTextWidth(chapter);
                    doc.text(chapter, (pageWidth - chapterWidth) / 2, currentY);

                    currentY += 10;
                    const tableColumn = ['Name', 'Balance'];

                    const tableData = cashaccountsdata.map((data) => {
                        return [
                            { content: data.name, styles: { fontStyle: 'normal' } },
                            { content: data.currency + ' ' + data.balance.toLocaleString("en-US"), styles: { fontStyle: 'normal' } }
                        ];
                    });

                    autoTable(doc, {
                        head: [tableColumn],
                        body: tableData,
                        startY: currentY,
                        theme: 'grid',
                        headStyles: {
                            fillColor: [200, 200, 200],
                            textColor: [0, 0, 0],
                            fontStyle: 'bold',
                        },
                        bodyStyles: {
                            fontSize: 10,
                            textColor: [0, 0, 0],
                            font: 'notoarabic',
                        },
                        columnStyles: {
                            0: { halign: 'left' },
                            1: { halign: 'left' },
                        },
                        margin: { top: 10, left: 10, right: 10 },
                    });
                    currentY = doc.lastAutoTable.finalY + 10;
                }

                if (visibility.profitloss.visible) {
                    currentY += 10;
                    doc.setFontSize(20);
                    const chapter = 'Profit & Loss';
                    const chapterWidth = doc.getTextWidth(chapter);
                    doc.text(chapter, (pageWidth - chapterWidth) / 2, currentY);

                    currentY += 10;
                    const tableColumn = ['Name', 'Actual', 'Budget', 'Percentage'];

                    const tableData = []

                    autoTable(doc, {
                        head: [tableColumn],
                        body: tableData,
                        startY: currentY,
                        theme: 'grid',
                        headStyles: {
                            fillColor: [200, 200, 200],
                            textColor: [0, 0, 0],
                            fontStyle: 'bold',
                        },
                        bodyStyles: {
                            fontSize: 10,
                            textColor: [0, 0, 0],
                            font: 'notoarabic',
                        },
                        columnStyles: {
                            0: { halign: 'left' },
                            1: { halign: 'right' },
                            2: { halign: 'right' },
                            3: { halign: 'center' },
                        },
                        margin: { top: 10, left: 10, right: 10 },
                    });
                    currentY = doc.lastAutoTable.finalY + 10;
                }

                if (visibility.cashflowstatement.visible) {
                    currentY += 10;
                    doc.setFontSize(20);
                    const chapter = 'Cash Flow Statement';
                    const chapterWidth = doc.getTextWidth(chapter);
                    doc.text(chapter, (pageWidth - chapterWidth) / 2, currentY);

                    currentY += 10;
                    const tableColumn = ['Name', 'Amount'];

                    const tableData = [].map((data) => {
                        if (data.tabletype === "section") return [
                            { content: data.name, styles: { fontStyle: 'bold' } },
                            { content: '', styles: { fontStyle: 'bold' } },
                        ];
                        if (data.tabletype === "accountinflows") return [
                            { content: '    ' + data.name, styles: { fontStyle: 'normal' } },
                            { content: data.currency + ' ' + data.amount, styles: { fontStyle: 'normal' } },
                        ];
                        if (data.tabletype === "accountoutflows") return [
                            { content: '    ' + data.name, styles: { fontStyle: 'normal' } },
                            { content: data.currency + ' ' + data.amount, styles: { fontStyle: 'normal' } },
                        ];
                        if (data.tabletype === "grouptotal") return [
                            { content: '    ' + data.name, styles: { fontStyle: 'normal' } },
                            { content: data.currency + ' ' + data.amount, styles: { fontStyle: 'normal' } },
                        ];
                        if (data.tabletype === "sectiontotal") return [
                            { content: data.name, styles: { fontStyle: 'bold' } },
                            { content: data.currency + ' ' + data.amount, styles: { fontStyle: 'bold' } },
                        ];
                    });

                    autoTable(doc, {
                        head: [tableColumn],
                        body: tableData,
                        startY: currentY,
                        theme: 'grid',
                        headStyles: {
                            fillColor: [200, 200, 200],
                            textColor: [0, 0, 0],
                            fontStyle: 'bold',
                        },
                        bodyStyles: {
                            fontSize: 10,
                            textColor: [0, 0, 0],
                            font: 'notoarabic',
                        },
                        columnStyles: {
                            0: { halign: 'left' },
                            1: { halign: 'right' },
                        },
                        margin: {
                            top: 10,
                            left: 10,
                            right: 10
                        },
                    });
                    currentY = doc.lastAutoTable.finalY + 10;
                }

                if (visibility.clientbalances.visible) {
                    currentY += 10;
                    doc.setFontSize(20);
                    const chapter = 'Client Balances';
                    const chapterWidth = doc.getTextWidth(chapter);
                    doc.text(chapter, (pageWidth - chapterWidth) / 2, currentY);

                    currentY += 10;
                    const tableColumn = [];

                    filteredclientscolumnheader.forEach(header => {
                        tableColumn.push(header);
                    });
                    const tableData = filteredclientscolumnrows.map((data) => {
                        return data.columns.map((column) => {
                            return { content: column, styles: { fontStyle: 'normal' } };
                        });
                    });

                    const footerRow = filteredclientscolumnfooter.map((data) => {
                        return { content: data, styles: { fontStyle: 'bold' } };
                    });
                    tableData.push(footerRow);

                    autoTable(doc, {
                        head: [tableColumn],
                        body: tableData,
                        startY: currentY,
                        theme: 'grid',
                        headStyles: {
                            fillColor: [200, 200, 200],
                            textColor: [0, 0, 0],
                            fontStyle: 'bold',
                        },
                        bodyStyles: {
                            fontSize: 10,
                            textColor: [0, 0, 0],
                            font: 'notoarabic',
                        },
                        margin: { top: 10, left: 10, right: 10 },
                    });
                    currentY = doc.lastAutoTable.finalY + 10;
                }

                if (visibility.collections.visible) {
                    currentY += 10;
                    doc.setFontSize(20);
                    const chapter = 'Client Balances';
                    const chapterWidth = doc.getTextWidth(chapter);
                    doc.text(chapter, (pageWidth - chapterWidth) / 2, currentY);

                    currentY += 10;
                    const tableColumn = ['Created', 'Due', 'Completed', '', 'Amount', 'Status'];

                    const tableData = collections.map((data) => {
                        const isDue = moment().unix() < moment.unix(data.atts).endOf('day').unix();
                        if (data.tabletype == 'receipt') {
                            const clientName = project.clients.find((client) => client.id === data.clientid)?.name;
                            const currencyName = project.currencies.find((currency) => currency.id === data.currencyid)?.name;
                            return [
                                { content: moment.unix(data.ts).format('dddd, D MMM YYYY hh:mm:ss A'), styles: { fontStyle: 'normal' } },
                                { content: moment.unix(data.atts).format('dddd'), styles: { fontStyle: 'normal' } },
                                { content: data.completedts && moment.unix(data.completedts).format('dddd, D MMM YYYY hh:mm:ss A'), styles: { fontStyle: 'normal' } },
                                { content: clientName, styles: { fontStyle: 'normal' } },
                                { content: data.amount + ' ' + currencyName, styles: { fontStyle: 'normal' } },
                                { content: data.status === 'pending' ? (isDue ? 'pending' : 'not due') : (data.status === 'received' ? 'received' : ''), styles: { fontStyle: 'bold' } }
                            ];
                        }
                        if (data.tabletype == 'payment') {
                            const supplierName = project.suppliers.find((supplier) => supplier.id === data.supplierid)?.name;
                            const currencyName = project.currencies.find((currency) => currency.id === data.currencyid)?.name;
                            return [
                                { content: moment.unix(data.ts).format('dddd, D MMM YYYY hh:mm:ss A'), styles: { fontStyle: 'normal' } },
                                { content: moment.unix(data.atts).format('dddd'), styles: { fontStyle: 'normal' } },
                                { content: data.completedts && moment.unix(data.completedts).format('dddd, D MMM YYYY hh:mm:ss A'), styles: { fontStyle: 'normal' } },
                                { content: supplierName, styles: { fontStyle: 'normal' } },
                                { content: data.amount + ' ' + currencyName, styles: { fontStyle: 'normal' } },
                                { content: data.status === 'pending' ? (isDue ? 'pending' : 'not due') : (data.status === 'received' ? 'received' : ''), styles: { fontStyle: 'bold' } }
                            ];
                        }
                    })

                    autoTable(doc, {
                        head: [tableColumn],
                        body: tableData,
                        startY: currentY,
                        theme: 'grid',
                        headStyles: {
                            fillColor: [200, 200, 200],
                            textColor: [0, 0, 0],
                            fontStyle: 'bold',
                        },
                        bodyStyles: {
                            fontSize: 10,
                            textColor: [0, 0, 0],
                            font: 'notoarabic',
                        },
                        columnStyles: {
                            0: { halign: 'left' },
                            1: { halign: 'left' },
                            1: { halign: 'left' },
                            1: { halign: 'left' },
                            1: { halign: 'left' },
                        },
                        margin: {
                            top: 10,
                            left: 10,
                            right: 10
                        },
                    });
                    currentY = doc.lastAutoTable.finalY + 10;
                }

                const fileName = 'Overall Report ' + projectName + '.pdf';
                doc.save(fileName.replace(/\s+/g, '_').toLowerCase());
                setResultpdf("Saved Successfully");
            } catch (error) {
                console.error('Error generating PDF:', error);
                setResultpdf("Error Saving PDF");
            } finally {
                setLoadingpdf(false);
            }
        };

        function OverallReportCashAccounts() {
            return (
                <div className="reports_section">
                    <div className="reports_sectiontitle">Cash Accounts</div>
                    <table className="reports_table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Balance</th>
                                <th>Reconciled</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cashaccountsdata.map((account, index) => {
                                return (
                                    <tr key={"account" + index} className="reports_tableitem" >
                                        <td>
                                            <div>{account.name}</div>
                                        </td>
                                        <td>
                                            <div>
                                                {account.currencysymbol + ' ' + account.balance.toLocaleString("en-US")}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {account.lastreconciled ? moment.unix(account.lastreconciled).format("D/MMM/YYYY") : ''}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )
        }

        function OverallReportCashFlowStatement() {
            const context = {
                ...project,
            };

            const cashflowdata = getcashflowstatementdata(context)

            return (
                <div className="reports_section">
                    <div className="reports_sectiontitle">Cash Flow Statement</div>
                    <table className="reports_table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                cashflowdata
                                    .map((data, index) => {
                                        if (data.tabletype == 'section') {
                                            return (
                                                <tr key={"data" + index} className="reports_tablesection">
                                                    <td colSpan={2}><div>{data.name}</div></td>
                                                </tr>
                                            )
                                        }
                                        if (data.tabletype == 'sectiontotal') {
                                            return (
                                                <tr key={"data" + index} className="reports_tablesectiontotal">
                                                    <td><div>{data.name}</div></td>
                                                    <td><div>{data.currency + ' ' + data.amount.toLocaleString("en-US")}</div></td>
                                                </tr>
                                            )
                                        }
                                        if (data.tabletype == 'group') {
                                            return (
                                                <tr key={"data" + index} className='reports_tablegroup'>
                                                    <td><div>{data.name}</div></td>
                                                    <td><div>{data.currency + ' ' + data.amount.toLocaleString("en-US")}</div></td>
                                                </tr>
                                            );
                                        }
                                        if (data.tabletype == 'grouptotal') {
                                            return (
                                                <tr key={"data" + index} className='reports_tablegrouptotal'>
                                                    <td><div>{data.name}</div></td>
                                                    <td><div>{data.currency + ' ' + data.amount.toLocaleString("en-US")}</div></td>
                                                </tr>
                                            );
                                        }
                                        if (data.tabletype == 'item') {
                                            return (
                                                <tr key={"data" + index} className="reports_tableitem">
                                                    <td>
                                                        <div>{data.name}</div>
                                                    </td>
                                                    <td>
                                                        <div
                                                            onClick={() =>
                                                                handleAccountStatement(
                                                                    'assetaccounts',
                                                                    {
                                                                        id: data.id,
                                                                        name: data.name,
                                                                        from: Math.floor(new Date(new Date(project.startdate * 1000).setHours(0, 0, 0, 0)).getTime() / 1000),
                                                                        to: Math.floor(new Date().setHours(23, 59, 59, 999) / 1000),
                                                                        subaccountid: 0,
                                                                        currencyid: project.basecurrency
                                                                    }
                                                                )}
                                                        >
                                                            {data.currency + ' ' + data.amount.toLocaleString("en-US")}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    })
                            }
                        </tbody>
                    </table>
                </div>
            )
        }

        function OverallReportProfitLoss() {
            const context = {
                ...project,
                selectedcurrencyid: 0,
                selectedsubaccountid: 0
            };

            const profitlossdata = getprofitlossreportdata(context)

            return (
                <div className="reports_section">
                    <div className="reports_sectiontitle">Profit & Loss</div>
                    <table className="reports_table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Actual</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                profitlossdata.map((data, index) => {
                                    if (data.tabletype == 'section') {
                                        return (
                                            <tr key={"data" + index} className="reports_tablesection">
                                                <td colSpan={2}>
                                                    <div>{data.name}</div>
                                                </td>
                                            </tr>
                                        );
                                    }
                                    if (data.tabletype == 'sectiontotal') {
                                        return (
                                            <tr key={"data" + index} className="reports_tablesectiontotal">
                                                <td>
                                                    <div>{data.name}</div>
                                                </td>
                                                <td>
                                                    <div>{data.currency + ' ' + data.amount.toLocaleString("en-US")}</div>
                                                </td>
                                            </tr>
                                        );
                                    }
                                    if (data.tabletype == 'group') {
                                        return (
                                            <tr key={"data" + index} className="reports_tablegroup">
                                                <td colSpan={2}>
                                                    <div>{data.name}</div>
                                                </td>
                                            </tr>
                                        );
                                    }
                                    if (data.tabletype == 'grouptotal') {
                                        return (
                                            <tr key={"data" + index} className="reports_tablegrouptotal">
                                                <td>
                                                    <div>{data.name}</div>
                                                </td>
                                                <td>
                                                    <div>{data.currency + ' ' + data.amount.toLocaleString("en-US")}</div>
                                                </td>
                                            </tr>
                                        );
                                    }
                                    if (data.tabletype == 'item') {
                                        return (
                                            <tr key={"data" + index} className="reports_tableitem">
                                                <td>
                                                    <div>{data.name}</div>
                                                </td>
                                                <td>
                                                    <div>
                                                        {data.currency + ' ' + data.amount.toLocaleString("en-US")}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    }
                                })
                            }
                        </tbody>
                    </table>
                </div>
            )
        }

        function OverallReportClientBalances() {
            return (
                <div className="reports_section">
                    <div className="reports_sectiontitle">Client Balances</div>
                    <table className="reports_table">
                        <thead>
                            <tr>
                                {
                                    filteredclientscolumnheader.map((headeritem, index) => {
                                        return <th key={"headeritem" + index}>
                                            {headeritem}
                                        </th>;
                                    })
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                filteredclientscolumnrows.map((row, index) => {
                                    return (
                                        <tr key={"row" + index}>
                                            {row?.columns.map((column, index) => (
                                                <td key={"column" + index}>
                                                    <div>{column}</div>
                                                </td>
                                            ))}
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                {filteredclientscolumnfooter.map((footerItem, index) => (
                                    <td key={"footer" + index}>
                                        <strong>{footerItem}</strong>
                                    </td>
                                ))}
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )
        }

        function OverallReportCollections() {
            return (
                <div className="reports_section">
                    <div className="reports_sectiontitle">Collections</div>
                    <table className='reports_table'>
                        <thead>
                            <tr>
                                <th>Created</th>
                                <th>Due</th>
                                <th>Completed</th>
                                <th>Client</th>
                                <th>Note</th>
                                <th>Amount</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                collections.map((collection, index) => {
                                    const isDue = moment().unix() < moment.unix(collection.atts).endOf('day').unix();
                                    if (collection.type == 'receipt') {
                                        const clientName = project.clients.find((client) => client.id === collection.clientid)?.name;
                                        const currencyName = project.currencies.find((currency) => currency.id === collection.currencyid)?.name;
                                        return (
                                            <tr key={'collection' + index} className='collections_receipt'>
                                                <td><div>{moment.unix(collection.ts).format('dddd, D MMM YYYY hh:mm:ss A')}</div></td>
                                                <td><div>{moment.unix(collection.atts).format('dddd')}</div></td>
                                                <td><div>{collection.completedts ? moment.unix(collection.completedts).format('dddd, D MMM YYYY hh:mm:ss A') : null}</div></td>
                                                <td><div>{clientName}</div></td>
                                                <td><div>{collection.note}</div></td>
                                                <td><div>{collection.amount} {currencyName}</div></td>
                                                {collection.status === 'pending' && isDue && <td><div className='collections_statuspending'>pending</div></td>}
                                                {collection.status === 'pending' && !isDue && <td><div className='collections_statusnotdue'>not due</div></td>}
                                                {collection.status === 'received' && <td><div className='collections_statusreceived'>received</div></td>}
                                            </tr>
                                        );
                                    }
                                })
                            }
                        </tbody>
                    </table>
                </div>
            )
        }

        function OverallReportPayments() {
            return (
                <div className="reports_section">
                    <div className="reports_sectiontitle">Payments</div>
                    <table className='reports_table'>
                        <thead>
                            <tr>
                                <th>Created</th>
                                <th>Due</th>
                                <th>Completed</th>
                                <th>Supplier</th>
                                <th>Note</th>
                                <th>Amount</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                collections.map((collection, index) => {
                                    const isDue = moment().unix() < moment.unix(collection.atts).endOf('day').unix();
                                    if (collection.type == 'payment') {
                                        const supplierName = project.suppliers.find((supplier) => supplier.id === collection.supplierid)?.name;
                                        const currencyName = project.currencies.find((currency) => currency.id === collection.currencyid)?.name;
                                        return (
                                            <tr key={'collection' + index} className='collections_payment'>
                                                <td><div>{moment.unix(collection.ts).format('dddd, D MMM YYYY hh:mm:ss A')}</div></td>
                                                <td><div>{moment.unix(collection.atts).format('dddd')}</div></td>
                                                <td><div>{collection.completedts ? moment.unix(collection.completedts).format('dddd, D MMM YYYY hh:mm:ss A') : null}</div></td>
                                                <td><div>{supplierName}</div></td>
                                                <td><div>{collection.note}</div></td>
                                                <td><div>{collection.amount} {currencyName}</div></td>
                                                {collection.status === 'pending' && isDue && <td><div className='collections_statuspending'>pending</div></td>}
                                                {collection.status === 'pending' && !isDue && <td><div className='collections_statusnotdue'>not due</div></td>}
                                                {collection.status === 'received' && <td><div className='collections_statusreceived'>received</div></td>}
                                            </tr>
                                        );
                                    }
                                })
                            }
                        </tbody>
                    </table>
                </div>
            )
        }

        function OverallReportLiabilities() {
            const context = {
                ...project,
            };

            const liabilityaccountsdata = getLiabilityAccounts(context);

            return (
                <div className="reports_section">
                    <div className="reports_sectiontitle">Liabilities</div>
                    <table className='reports_table'>
                        <thead><tr><th>Name</th><th>Balance</th></tr></thead>
                        <tbody>
                            {
                                liabilityaccountsdata.map((account, index) => {
                                    if (account.balance != 0) return (
                                        <tr key={'account' + index}>
                                            <td><div>{account.name}</div></td>
                                            <td>
                                                <div>{account.currencysymbol + ' ' + account.balance.toLocaleString('en-US')}</div>
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </table>
                </div>
            )
        }

        function OverallReportSuppliers() {
            const context = {
                ...project,
            };

            const suppliersdata = getSupplierAccounts(context);

            return (
                <div className="reports_section">
                    <div className="reports_sectiontitle">Suppliers</div>
                    <table className='reports_table'>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Balance</th>
                                <th>Reconciled</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                suppliersdata.map((supplier, index) => {

                                    return (
                                        <tr key={'supplier' + index}>
                                            <td><div>{supplier.name}</div></td>
                                            <td>
                                                <div>{supplier.currencysymbol} {supplier.balance.toLocaleString('en-US')}</div>
                                            </td>
                                            <td>
                                                <div>{supplier.reconciled}</div>
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </table>
                </div>
            )
        }

        function OverallReportStaff() {
            const context = {
                ...project,
            };

            const staffaccountsdata = getStaffAccounts(context);

            return (
                <div className="reports_section">
                    <div className="reports_sectiontitle">Staff</div>
                    <table className='reports_table'>
                        <thead><tr><th>Name</th><th>Balance</th></tr></thead>
                        <tbody>
                            {
                                staffaccountsdata.map((staff, index) => {
                                    if (staff.balance != 0) return (
                                        <tr key={'staff' + index}>
                                            <td><div>{staff.name}</div></td>
                                            <td>
                                                <div>{staff.currencysymbol + ' ' + staff.balance.toLocaleString('en-US')}</div>
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </table>
                </div>
            )
        }

        function OverallReportAssets() {
            const context = {
                ...project,
            };

            const assetaccountsdata = getAssetAccounts(context);

            return (
                <div className="reports_section">
                    <div className="reports_sectiontitle">Assets</div>
                    <table className='reports_table'>
                        <thead><tr><th>Name</th><th>Amount</th></tr></thead>
                        <tbody>
                            {
                                assetaccountsdata.map((asset, index) => {
                                    return (
                                        <tr key={'asset' + index}>
                                            <td><div>{asset.name}</div></td>
                                            <td>
                                                <div>{asset.currencysymbol + ' ' + asset.balance.toLocaleString('en-US')}</div>
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </table>
                </div>
            )
        }

        return (
            <div className="report">
                <div className="reports_buttonscontainer">
                    <ReactToPrint
                        trigger={() => (<button className="reports_button">Print</button>)}
                        content={() => printRef.current}
                    />
                    <button className="reports_button" onClick={saveAsPDF}>
                        Save as PDF {loadingpdf && '(Loading...)'} {resultpdf && "(" + resultpdf + ")"}
                    </button>
                </div>
                <div className="reports_buttonscontainer">
                    <ul>
                        {Object.entries(visibility).map(([key, { visible, name, disabled }]) => (
                            <li key={key}>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={visible}
                                        disabled={disabled}
                                        onChange={() =>
                                            !disabled &&
                                            setVisibility((prevState) => ({
                                                ...prevState,
                                                [key]: { ...prevState[key], visible: !prevState[key].visible },
                                            }))
                                        }
                                    />
                                    {name}
                                </label>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className='reports_note'>
                    Please make sure to complete the data entry before sending the report. By reconciling the cash accounts and finalizing the budget chart with their corresponding estimated budget.
                </div>
                <div className="reports_printable" ref={printRef}>
                    <div className="reports_headerrow">
                        <div className="reports_headercolleft">
                            {project.projectdetailsimage && (
                                <img
                                    className="reports_projectdetailsimage"
                                    src={project.projectdetailsimage}
                                    alt="Project Details Image"
                                />
                            )}
                        </div>
                        <div className="reports_headercolmiddle">
                            <div className="reports_title">Report</div>
                            <div className="reports_projectname">{project.name}</div>
                            <div className="reports_dateframe">
                                {moment.unix(fromts).format("D/MMM/YYYY") + ' to ' + moment.unix(tots).format("D/MMM/YYYY")}
                            </div>
                        </div>
                        <div className="reports_headercolright"></div>
                    </div>
                    <div className="reports_section">
                        <div className="reports_sectiontitle">Table of Contents</div>

                        <ul>
                            {Object.entries(visibility)
                                .filter(([_, value]) => value.visible)
                                .map(([key, value]) => (
                                    <li key={key}>{value.name}</li>
                                ))}
                        </ul>
                    </div>

                    {visibility.cashaccounts.visible && <OverallReportCashAccounts />}
                    {visibility.cashflowstatement.visible && <OverallReportCashFlowStatement />}
                    {visibility.profitloss.visible && <OverallReportProfitLoss />}
                    {visibility.clientbalances.visible && <OverallReportClientBalances />}
                    {visibility.collections.visible && <OverallReportCollections />}
                    {visibility.payments.visible && <OverallReportPayments />}
                    {visibility.liabilities.visible && <OverallReportLiabilities />}
                    {visibility.suppliers.visible && <OverallReportSuppliers />}
                    {visibility.staff.visible && <OverallReportStaff />}
                    {visibility.assets.visible && <OverallReportAssets />}
                </div>
            </div>
        );
    }

    return (
        <div className='reports'>
            <Title text='reports' />

            <div className="reports_row">
                <div className="reports_rowsection">From</div>
                <div className="reports_rowsection">
                    <DatePicker
                        className="reports_datepicker"
                        selected={from}
                        onChange={(date) => setFrom(date)}
                    />
                </div>
                <div className="reports_rowsection">To</div>
                <div className="reports_rowsection">
                    <DatePicker
                        className="reports_datepicker"
                        selected={to}
                        onChange={(date) => setTo(date)}
                    />
                </div>
            </div>

            <div className='buttonscontainer'>
                <button className='button' onClick={handleGeneralLedger}>General Ledger</button>
                <button className='button' onClick={handleReceiptsPayments}>Receipts & Payments</button>
                <button className='button' onClick={handleProfitLoss}>Profit and Loss</button>
                <button className='button' onClick={handleBalanceSheet}>Balance Sheet</button>
                <button className='button' onClick={handleCashFlow}>Cash Flow</button>
                <button className='button' onClick={handleTrialBalance}>Trial Balance</button>
            </div>
            <div className='buttonscontainer'>
                <button className="reports_button" onClick={handleInvoicesReport}>Invoices</button>
                <button className="reports_button" onClick={handleItemsQuantityReport}>Items by quantity</button>
                <button className="reports_button" onClick={handleItemsValueReport}>Items by value</button>
            </div>
            <div className='buttonscontainer'>
                <button className="reports_button" onClick={handleOverallReport}>
                    Overall Report
                </button>
            </div>

            {option}

        </div>
    );
}

export default Reports;